import dayjs, { Dayjs } from 'dayjs'
import DatePickerService from '../service/_datePicker'
import { objectToGet } from '../functions/index'
import { difference, sum } from 'lodash'
import closingDay from '../const/_closing-day'

/**
 * DatePickerTemplate // キーワード選択ボタンのテンプレート
 *
 * @returns {undefined}
 */

class DatePickerTemplate {
  /**
   * get // 深い階層のオブジェクトを取得する
   *
   * @param {object} data
   * @param {string} name
   * @param {any} defaultValue
   */
  get(data, name, defaultValue = null) {
    return objectToGet(data, name, defaultValue)
  }

  render(calendarDate, nowDate, regulationDate) {
    return this.calendar(calendarDate, nowDate)
  }

  calendar(calendarDate, nowDate) {
    const year = calendarDate.year()
    const month = calendarDate.month()
    const next = DatePickerService.nextMonth(calendarDate)

    const displayMonth = month + 1
    const displayMonthNext = DatePickerService.monthManager(displayMonth + 1)
    const prevLinks = this.prevLinks(year, displayMonth)
    const nextLinks = this.nextLinks(year, displayMonth)

    const table = this.calendarBody(calendarDate, nowDate)
    const table2 = this.calendarBody(next, nowDate)
    return `
<div class="datePickerCalendar">
  <div class="datePickerCalendar__head">
      <div class="datePickerCalendar__headItem">${prevLinks}</div>
      <div class="datePickerCalendar__headItem">${displayMonth}月 ${year}</div>
      <div class="datePickerCalendar__headItem">${nextLinks}</div>
  </div>
  <div class="datePickerCalendar__body">
      <div class="datePickerCalendar__month">${displayMonth}月</div>
      ${table}
  </div>
  <div class="datePickerCalendar__body datePickerCalendar__body__right datePickerCalendar__body--spNone">
      <div class="datePickerCalendar__month">${displayMonthNext}月</div>
      ${table2}
  </div>
</div>
`
  }

  link(year, month, number) {
    let monthNum = parseInt(month) + parseInt(number)
    const yearNum = DatePickerService.yearManager(parseInt(year), monthNum)
    monthNum = DatePickerService.monthManager(monthNum)

    const cDay = this.get(closingDay, '0.day', 14) - 1
    const regulationDate = dayjs().add(cDay, 'day')
    const targetMonth = sum([month, number])
    const date = dayjs(`${year}-${targetMonth}-1`).endOf('month')
    const diffDay = date.diff(regulationDate, 'day')
    let link = ''
    if (diffDay <= 0) {
      link = `<span class="datePickerCalendar__headText">${monthNum}月</span>`
    } else {
      link = `<a class="datePickerCalendar__headLink js-date-picker-select-month" data-year="${yearNum}" data-month="${monthNum}">${monthNum}月</a>`
    }
    return link
  }

  prevLinks(year, month) {
    let html = ''
    html += this.link(year, month, -3)
    html += this.link(year, month, -2)
    html += this.link(year, month, -1)
    return html
  }

  nextLinks(year, month) {
    let html = ''
    html += this.link(year, month, 1)
    html += this.link(year, month, 2)
    html += this.link(year, month, 3)
    return html
  }

  /**
   * calendarBody // カレンダーのhtmlを返す
   *
   * @param {int} year
   * @param {int} month
   */
  calendarBody(calendarDate, nowDate) {
    const array = DatePickerService.array(calendarDate, nowDate)
    let html = `<table><thead>
          <tr>
              <th>月</th>
              <th>火</th>
              <th>水</th>
              <th>木</th>
              <th>金</th>
              <th>土</th>
              <th>日</th>
          </tr></thead><tbody>`
    array.map(week => {
      html += '<tr>'
      week.map(dayData => {
        html += this.day(dayData)
      })
      html += '</tr>'
    })
    html += `</tbody></table>`
    return html
  }

  /**
   * holidayClass // 祝日にクラスを返す
   *
   * @param {boolean} isHoliday
   */
  holidayClass(isHoliday) {
    return isHoliday ? 'holiday' : ''
  }

  /**
   * day // 日付のhtmlを返す
   *
   * @param {} month
   * @param {} day
   * @param {object} item // priceデータなど
   * @param {string} date // 日付 2021-01-12
   * @param {object} participants // 参加者
   */
  day(data) {
    const holidayClass = this.holidayClass(this.get(data, 'isHoliday', false))
    const cDay = this.get(closingDay, '0.day', 14) - 1
    const regulationDate = dayjs().add(cDay, 'day')
    const date = dayjs(this.get(data, 'date', false))
    const dayNum = this.get(data, 'day', 0)
    const isSelectDay = this.get(data, 'isSelectDay', false)
    const isDisable = this.isDisableDate(date, regulationDate)
    let selected = ''
    if (isSelectDay) selected = ' selected'
    var disable = ''
    if (isDisable) disable = ' disable'

    if (dayNum === 0) return `<td class="${holidayClass}"></td>`
    return `<td class="datePickerCalendar__body js-date-picker-select-dey ${selected} ${holidayClass} ${disable}" data-day="${date}"><span class="cal_inner"><div class="datePickerCalendar__date">${dayNum}</div></span></td>`
  }

  /**
   * disableDate // 過去日判定
   *
   * @param {Dayjs} date1
   * @param {Dayjs} date2
   *
   * @return {boolean}
   */
  isDisableDate(date1, date2) {
    return date1.isBefore(date2)
  }
}

export default new DatePickerTemplate()
